<template>
  <JetfiCountries />
</template>

<script>
// @ is an alias to /src
import JetfiCountries from '@/components/JetfiCountries.vue'

export default {
  name: "jetficountries",
  data: function() {
    return {
      baseUrl: process.env.baseUrl,
      
    };
  },
  created: function(){
      
  },
  components: {
    JetfiCountries
  }
};
</script>
